import Vue from 'vue'
import Router from 'vue-router'
import Key from '@/components/main/key'
import Tiaow from '@/components/main/tiaow'
import MuBiao from '@/components/main/mubiao'
import Login from '@/components/main/login'


Vue.use(Router)

export default new Router({
  mode: 'history',
  bash: '/',
  routes: [
    {
      path: '/',
      component: Login
    },
		{
		  path: '/key',
		  name: 'Key',
		  component: Key
		},
		{
		  path: '/mubiao',
		  name: 'MuBiao',
		  component:MuBiao
		},
		{
		  path: '/tiaow',
		  name: 'Tiaow',
		  component:Tiaow
		},

    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js